var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 187,
    viewBox: "0 0 200 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_124_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 160,
    height: 69
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.667 0H179.334V68.7083H20.667V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_124_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.74 61.8854H169.635C173.234 61.8854 176.224 64.5417 176.75 68C177.292 67.8906 177.833 67.8073 178.385 67.7448C176.589 61.6458 174.229 55.7656 171.354 50.2188C169.443 46.526 167.297 42.9844 164.938 39.6094C166.172 36.8542 165.755 33.7188 163.833 31.3854C163.172 30.5781 162.49 29.776 161.802 28.9948C145.354 10.2969 123.406 0 100 0C76.5885 0 54.6458 10.2969 38.1979 28.9948C37.5104 29.776 36.8281 30.5781 36.1667 31.3854C34.2448 33.7188 33.8333 36.8542 35.0625 39.6094C32.7031 42.9844 30.5573 46.526 28.6406 50.2188C25.7656 55.7656 23.4063 61.6458 21.6094 67.7448C22.1615 67.8073 22.7083 67.8906 23.25 68C23.776 64.5417 26.7656 61.8854 30.3646 61.8854H31.2604C33.7917 55.4896 36.9583 49.5417 40.6667 44.1354C41.1875 44.2396 41.724 44.2969 42.276 44.2969C44.6406 44.2969 46.8646 43.2448 48.375 41.4063C56.8333 31.1198 67.5052 23.5052 79.2344 19.3698C85.9323 17.0052 92.9167 15.8073 100 15.8073C119.38 15.8073 138.198 25.1458 151.62 41.4271C153.12 43.2552 155.339 44.2969 157.698 44.2969H157.724C158.276 44.2969 158.813 44.2396 159.328 44.1354C163.021 49.526 166.198 55.4635 168.74 61.8854Z",
    fill: "#E101CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_124_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 133,
    width: 77,
    height: 54
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8594 133.391H103.182V187H27.8594V133.391Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_124_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.166 175.698H102.161C100.828 173.292 98.2861 171.797 95.5361 171.797C93.0934 171.797 90.7861 172.984 89.3643 174.979L88.4372 176.281L86.8591 175.984C73.0882 173.37 60.0205 166.417 49.0674 155.88C42.4893 149.552 36.8799 142.177 32.3851 133.932H30.3643C29.4788 133.932 28.6351 133.755 27.8643 133.432C29.5465 136.719 31.4007 139.891 33.4163 142.932C37.2132 148.656 41.5986 153.927 46.458 158.599C52.2445 164.167 58.5986 168.797 65.3434 172.359C72.0257 175.891 79.0726 178.37 86.2966 179.724L87.8226 180.005L88.2445 181.5C89.1716 184.74 92.1716 187 95.5361 187C98.6247 187 101.38 185.151 102.552 182.297C102.932 181.37 103.125 180.396 103.125 179.401C103.125 178.099 102.797 176.823 102.166 175.703V175.698Z",
    fill: "#E101CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_124_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 63,
    width: 33,
    height: 70
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 63.375H32.6667V132.708H0V63.375Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_124_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8486 131.417C31.3799 131.417 31.8122 130.984 31.8122 130.453V65.3281C31.8122 64.7969 31.3747 64.3594 30.8434 64.3594H30.307C26.9997 64.3594 24.2913 67.0729 24.2913 70.3854C22.6611 69.6094 20.8538 69.151 18.9476 69.0885C18.7653 69.0833 18.5882 69.0833 18.4059 69.0833C17.8903 69.0833 17.3851 69.1042 16.8799 69.151C9.37468 69.8021 3.11426 75.224 1.28092 82.4219C0.968423 83.651 0.780925 84.9271 0.744466 86.2396L0.0569661 108.583C0.0517568 108.813 0.0517578 109.042 0.0517578 109.266C0.124675 118.693 7.69759 126.526 17.1872 126.818C17.3226 126.823 17.458 126.823 17.5986 126.823C18.5153 126.823 19.4163 126.729 20.2861 126.547C21.7132 126.255 23.0622 125.734 24.2913 125.021C24.2913 128.542 27.1611 131.417 30.6768 131.417H30.8486Z",
    fill: "#E101CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_124_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 63,
    width: 33,
    height: 70
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.333 63.375H200V132.708H167.333V63.375Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_124_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.942 108.583L199.255 86.2396C199.218 84.9271 199.031 83.651 198.718 82.4219C196.885 75.224 190.625 69.8021 183.114 69.1458C182.614 69.1042 182.104 69.0833 181.593 69.0833C181.411 69.0833 181.234 69.0833 181.052 69.0885C179.14 69.151 177.333 69.6094 175.708 70.3854C175.708 67.0729 173 64.3594 169.692 64.3594H169.151C168.619 64.3594 168.187 64.7969 168.187 65.3281V80.4375C168.057 81.2552 168 82.099 168.026 82.9531L168.187 88.2083V130.453C168.187 130.984 168.619 131.417 169.151 131.417H169.323C172.833 131.417 175.708 128.542 175.708 125.021C175.989 125.182 176.27 125.333 176.562 125.474C178.333 126.339 180.317 126.823 182.406 126.823C182.541 126.823 182.677 126.823 182.812 126.818C192.302 126.526 199.875 118.693 199.948 109.266C199.948 109.042 199.948 108.813 199.942 108.583Z",
    fill: "#E101CB"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.099 91.4948C128.87 95.9635 125.245 99.5989 120.776 99.8229C115.563 100.088 111.282 95.802 111.547 90.5781C111.771 86.1093 115.396 82.4739 119.865 82.25C125.078 81.9843 129.36 86.276 129.099 91.4948ZM108.776 91.4948C108.547 95.9635 104.922 99.5989 100.459 99.8229C95.2451 100.088 90.9587 95.802 91.2243 90.5781C91.4482 86.1093 95.0785 82.4739 99.542 82.25C104.756 81.9843 109.042 86.276 108.776 91.4948ZM88.4535 91.4948C88.2295 95.9635 84.5993 99.5989 80.1357 99.8229C74.9222 100.088 70.641 95.802 70.9014 90.5781C71.1305 86.1093 74.7555 82.4739 79.2191 82.25C84.4378 81.9843 88.7191 86.276 88.4535 91.4948ZM156.724 90.4062C156.724 61.5104 131.328 38.0885 100 38.0885C68.6722 38.0885 43.2764 61.5104 43.2764 90.4062C43.2764 119.297 68.6722 142.719 100 142.719C108.162 142.719 115.917 141.13 122.933 138.266C125.849 137.073 129.078 136.875 132.125 137.687L151.068 142.771C153.073 143.312 154.912 141.469 154.375 139.458L150.047 123.286C149.104 119.766 149.542 116.031 151.214 112.797C154.729 106.01 156.724 98.427 156.724 90.4062Z",
    fill: "#E101CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.812144aea292a5a760fd43dac9a73585.svg";
export { ForwardRef as ReactComponent };